import React, { useState,useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Row } from 'reactstrap';

function JobReferenceFieldArray({
  jobreferenceJson = [],
  jobnumbers,
  onSave,
  currentState,
  totalcount,
  currentJob,
}) {
  const [selectedJobs, setSelectedJobs] = useState( []);
  const [selectedJob, setSelectedJob] = useState(''); 

  useEffect(() => {
  if (!Array.isArray(jobnumbers)) {
      setSelectedJobs([]);
    return;
  }

 

  setSelectedJobs(
    jobnumbers.map(job =>({ 
      jobNumber: job.jobNumber,
      shortname: job.shortname,
       treatmentrecordcount: job.treatmentrecordcount,
    }))
  );
}, [jobnumbers]);

 useEffect(() => {
    if (onSave) {
        onSave(selectedJobs);
    }
}, [selectedJobs]);


  /*
   * Add selected Genesys Job
   */
  const addJob = () => {
    if (!selectedJob) {
      return;
    }

    const job = jobreferenceJson.find(
      item =>
        String(item.jobNumber) ===
        String(selectedJob)
    );

    if (!job) {
      return;
    }

    /*
     * Don't allow the same job twice
     */
    const alreadyExists = selectedJobs.some(
      item =>
        String(item.jobNumber) ===
        String(job.jobNumber)
    );

    if (alreadyExists) {
      return;
    }

    /*
     * Add the new job
     */
    setSelectedJobs(prevJobs => [
      ...prevJobs,
      {
        ...job
      }
    ]);

    /*
     * Clear job selector
     */
    setSelectedJob('');
  };

  /*
   * Remove selected Job
   */
  const removeJob = (jobNumber) => {
   currentJob.jobReference !=jobNumber && currentState!='verified' &&currentState!='certified' &&currentState!='failed' && currentState!='cancelled'? 
      
    setSelectedJobs(prevJobs =>
      prevJobs.filter(
        job =>
          String(job.jobNumber) !==
          String(jobNumber)
      )
    ):null;
  };

  /*
   * Job selector changed
   */
  const handleJobChange = (selectedOption) => {
    setSelectedJob(
      selectedOption
        ? selectedOption.value
        : ''
    );
  };

  /*
   * SAVE
   */
  const handleSave = () => {
    console.log(
      'Saving JOB data:',
      selectedJobs
    );

    if (onSave) {
      onSave(selectedJobs);
    }
  };

  return (
    <div>
     
      {/* ADD JOB SECTION */}
              {currentState!='verified' &&currentState!='certified' &&currentState!='failed' && currentState!='cancelled'? 
      <div
        style={{
          display: 'block',
          clear: 'both',
          width: '500px',
          boxSizing: 'border-box',
          padding: '15px',
          marginBottom: '20px',
          border: '1px solid #ccc',
          borderRadius: '4px'
        }}
      >
        
        <div
          style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              fontWeight: 'bold'
            }}
          >
            Add Related Genesys Jobs
          </div>
          <div
            style={{
              display: 'flex',
              gap: '8px'
            }}
          >
            <div
              style={{
                width: '200px'
              }}
            >
              <Select
                value={
                  jobreferenceJson
                    .map(job => ({
                      value: job.jobNumber,
                      label: `${job.jobNumber} (${job.treatmentrecordcount}) ${job.shortname}`
                    }))
                    .find(
                      option =>
                        String(option.value) ===
                        String(selectedJob)
                    ) || null
                }
                onChange={handleJobChange}
                options={jobreferenceJson
                  .filter(
                    job =>
                      !selectedJobs.some(
                        selected =>
                          String(selected.jobNumber) ===
                          String(job.jobNumber)
                      )
                  )
                  .map(job => ({
                    value: job.jobNumber,
                    label: `${job.jobNumber} ${job.treatmentrecordcount} ${job.shortname} `
                  }))}
                placeholder="Search Jobs"
                isClearable
                isSearchable
                noOptionsMessage={() =>
                  'No Jobs found'
                }
              />
            </div>

            <button
              type="button"
              onClick={addJob}
            >
              +
            </button>
          </div>
        </div>
        
      </div>
      :null}
      

      {/* SELECTED JOBS */}
      <div
        style={{
          clear: 'both',
          width: '70%'
        }}
      >
        {selectedJobs.length > 0 && (
          <div
            style={{
              fontWeight: 'bold',
              marginBottom: '10px'
            }}
          >
            Selected Jobs
          </div>
        )}
        <div>{'Total Enclosures: '+totalcount}</div>

        <div>
          <Row className="align-items-center">
            {selectedJobs.map(job => (
              <div
                key={job.jobNumber}
                style={{
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  boxSizing: 'border-box',
                  width: 'auto',
                  marginRight: '10px',
                  marginBottom: '10px'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '8px'
                  }}
                >
                  <span>
                     {job.jobNumber + " "}
                      {job.treatmentrecordcount + " "}
                    {job.shortname}
                  </span>
  

                  <span
                    style={{
                      marginLeft: '8px'
                    }}
                  >
                   
                  </span>

                  <span
                    title="Remove Job"
                    onClick={() =>
                      removeJob(job.jobNumber)
                    }
                    style={{
                      cursor: 'pointer',
                      marginLeft: '10px',
                      fontSize: '20px',
                      fontWeight: 'bold'
                    }}
                  >
                    ×
                  </span>
                </div>
              </div>
            ))}
          </Row>
        </div>
      </div>
    </div>
  );
}

JobReferenceFieldArray.propTypes = {
  jobreferenceJson: PropTypes.array,
   jobnumbers: PropTypes.array,
  onSave: PropTypes.func
};

export default JobReferenceFieldArray;
